<template>
  <div class="modal-information" v-if="information">
    <EditInfo v-if="$store.state.addEdit.showEditInfo" />
    <IUJP v-if="$store.state.modalStore.showIujp" :iujpData="information.iujp" />
    <IUJPTL v-if="$store.state.modalStore.showIujptl" :iujptlData="iujptl" />
    <INUBBM v-if="$store.state.modalStore.showInubbm" :inubbmData="inubbm" />
    <SBUJK v-if="$store.state.modalStore.showSbujk" :propsData="sbujk" />
    <DirekturEdit v-if="$store.state.modalStore.showDirektur" :propsData="direktur" />
    <KomisarisEdit v-if="$store.state.modalStore.showKomisaris" :propsData="komisaris" />
    <PemilikSahamEdit v-if="$store.state.modalStore.showPemilikSaham" :propsData="pemilikSaham" />
    <PICEdit v-if="$store.state.modalStore.showPic" :propsData="pic" />
    <IdentityEdit v-if="$store.state.modalStore.showIdentity" :propsData="identity" />
    <SubKbliEdit v-if="$store.state.addEdit.subKbliEdit" :propsData="kbliEditData" />
    <AddKbli v-if="$store.state.addEdit.addKbli" />
    <div class="information-wrapper">
      <div class="info-title">
        Nama Vendor<i class="fa fa-edit pointer ml20" @click="editInfo()" v-if="editingStatus && editingUser"></i>
      </div>
      <div class="info-content">{{ information.nama_vendor }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Badan Usaha</div>
      <div class="info-content">
        {{ $get(information, 'badan_usaha.desc', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Bidang Usaha</div>
      <div class="info-content">
        {{ $get(information, 'badan_usaha.bidang_usaha.desc', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Isupplier Code</div>
      <div class="info-content">
        {{ $get(information, 'isupplier_code', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Ariba Code</div>
      <div class="info-content">{{ information.ariba_code }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">BCE Code</div>
      <div class="info-content">{{ information.bce_code }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">GEMS Code</div>
      <div class="info-content">{{ information.gems_code }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">BKES Code</div>
      <div class="info-content">{{ information.bkes_code }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Tipe Pendaftaran</div>
      <div class="info-content">
        {{ $get(information, 'badan_usaha.type_pendaftaran.desc', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Tanggal Berdiri</div>
      <div class="info-content">
        {{ formatDate(information.tanggal_berdiri) }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Kegiatan Usaha Utama di Sistem OSS
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="showKbliEdit()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Kode</div>
        <div class="column40">Judul</div>
        <div class="column10">NIB</div>
        <div class="column10">SS IZIN</div>
        <div class="column20">Izin Dokumen Lainnya</div>
        <div></div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.kbli" :key="index">
        <div class="column20">{{ $get(list, 'kbli_sub.kode', '-') }}</div>
        <div class="column40 all-column">
          {{ $get(list, 'kbli_sub.desc', '-') }}
        </div>
        <div class="column10">{{ list.nib ? 'Ya' : 'Tidak' }}</div>
        <div class="column10">{{ list.ss_izin ? 'Ya' : 'Tidak' }}</div>
        <div class="column20">{{ list.dokumen_lainnya ? 'Ya' : 'Tidak' }}</div>
        <div>
          <i class="fa fa-edit" @click="editKbliId(list)" v-if="editingStatus && editingUser"></i>
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        IUJP
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="showIujp()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Jenis</div>
        <div class="column20">Bidang</div>
        <div class="column60">Sub Bidang</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.iujp" :key="index"
        v-if="list && list.master_iujp">
        <div class="column20">{{ $get(list, 'master_iujp.jenis', '-') }}</div>
        <div class="column20 all-column">
          {{ $get(list, 'master_iujp.bidang', '-') }}
        </div>
        <div class="column60 all-column">
          {{ $get(list, 'master_iujp.sub_bidang', '-') }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        SBUJK
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="showSbujk()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Kode</div>
        <div class="column20">Klasifikasi</div>
        <div class="column25">Sub Klasifikasi</div>
        <div class="column25">Kualifikasi</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.sbujk" :key="index">
        <div class="column20 all-column">
          {{ $get(list, 'master_sbujk.kode', '-') }}
        </div>
        <div class="column20 all-column">
          {{ $get(list, 'master_sbujk.klasifikasi', '-') }}
        </div>
        <div class="column25 all-column">
          {{ $get(list, 'master_sbujk.sub_klasifikasi', '-') }}
        </div>
        <div class="column25 all-column">
          {{ $get(list, 'master_sbujk.kualifikasi', '-') }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        IUJPTL
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="showIujptl()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Jenis Usaha</div>
        <div class="column20">Bidang</div>
        <div class="column25">Sub Bidang</div>
        <div class="column25">Kualifikasi</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.iujptl" :key="index">
        <div class="column20 all-column">
          {{ $get(list, 'master_iujptl.jenis_usaha', '-') }}
        </div>
        <div class="column20 all-column">
          {{ $get(list, 'master_iujptl.bidang', '-') }}
        </div>
        <div class="column25 all-column">
          {{ $get(list, 'master_iujptl.sub_bidang', '-') }}
        </div>
        <div class="column25 all-column">
          {{ $get(list, 'master_iujptl.kualifikasi', '-') }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        INU BBM
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="showInubbm()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Bidang</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.inu_bbm" :key="index">
        <div class="column100">
          {{ $get(list, 'master_inu_bbm.desc', '-') }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        SIUPAL
        <span class="edit-info" v-if="editingStatus && editingUser">
          <!-- <i class="fa fa-edit" @click="showInubbm()"></i> -->
        </span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Bidang</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.siupal" :key="index">
        <div class="column100">
          {{ $get(list, 'master_siupal.desc', '-') }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Alamat</div>
      <div class="info-content">{{ $get(information, 'alamat', '-') }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kode Negara</div>
      <div class="info-content">
        {{ $get(information, 'negara.kode_negara') }} -
        {{ $get(information, 'negara.negara') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Provinsi</div>
      <div class="info-content">
        {{
          $get(information, 'negara.id') == 63
            ? $get(information, 'provinsi.desc', '-')
            : $get(information, 'provinsi_asing', '-')
        }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kota/Kabupaten</div>
      <div class="info-content">
        {{
          $get(information, 'negara.id') == 63
            ? $get(information, 'kota.desc', '-')
            : $get(information, 'kota_asing', '-')
        }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kecamatan</div>
      <div class="info-content">
        {{ $get(information, 'kecamatan.desc', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kelurahan</div>
      <div class="info-content">
        {{ $get(information, 'kelurahan.desc', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kode Pos</div>
      <div class="info-content">
        {{
          $get(information, 'negara.id') == 63
            ? $get(information, 'kelurahan.kodepos', '-')
            : $get(information, 'kode_pos_asing', '-')
        }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">No Handphone</div>
      <div class="info-content">
        {{ $get(information, 'no_handphone', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Email</div>
      <div class="info-content">{{ $get(information, 'email', '-') }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Nama Pemilik Rekening</div>
      <div class="info-content">
        {{ $get(information, 'nama_pemilik_rekening', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Negara Bank</div>
      <div class="info-content">
        {{ $get(information, 'negara.negara', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Nama Bank</div>
      <div class="info-content">{{ $get(information, 'bank.desc', '-') }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Kantor Cabang</div>
      <div class="info-content">
        {{ $get(information, 'kantor_cabang', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Mata Uang</div>
      <div class="info-content">{{ $get(information, 'mata_uang', '-') }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Nomor Rekening</div>
      <div class="info-content">
        {{ $get(information, 'no_rekening', '-') }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Nomor NPWP</div>
      <div class="info-content">{{ $get(information, 'no_npwp', '-') }}</div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Direktur
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="addDirektur(information.direktur)"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column15">Jabatan</div>
        <div class="column20">Nama</div>
        <div class="column25">Nomor Handphone</div>
        <div class="column25">Email</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in sortDirekturKomisaris(information.direktur)" :key="index">
        <div class="column15">
          {{ list.jabatan && list.jabatan.toUpperCase() }}
        </div>
        <div class="column20">{{ $get(list, 'nama', '-') }}</div>
        <div class="column25">{{ $get(list, 'no_handphone', '-') }}</div>
        <div class="column25">{{ $get(list, 'email', '-') }}</div>
        <div class="column5">
          <i class="fa fa-edit pointer" @click="showDirektur(list)" v-if="editingStatus && editingUser"></i>
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Komisaris
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="addKomisaris(information.komisaris)"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column15">Jabatan</div>
        <div class="column20">Nama</div>
        <div class="column25">Nomor Handphone</div>
        <div class="column25">Email</div>
        <div class="column25"></div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in sortDirekturKomisaris(information.komisaris)" :key="index">
        <div class="column15">
          {{ list.jabatan && list.jabatan.toUpperCase() }}
        </div>
        <div class="column20">{{ $get(list, 'nama', '-') }}</div>
        <div class="column25">{{ $get(list, 'no_handphone', '-') }}</div>
        <div class="column25">{{ $get(list, 'email', '-') }}</div>
        <div class="column5">
          <i class="fa fa-edit pointer" @click="showKomisaris(list)" v-if="editingStatus && editingUser"></i>
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Pemilik Saham
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit"
            @click="addPemilikSaham(information.pemilik_saham)"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column40">Nama Pemegang Saham</div>
        <div class="column55">% Saham</div>
        <div class="column5"></div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.pemilik_saham" :key="index">
        <div class="column40">{{ $get(list, 'nama', '-') }}</div>
        <div class="column55">{{ convertNumberDescimal(list.persen) }}</div>
        <div class="column5">
          <i class="fa fa-edit pointer" @click="showPemilikSaham(list, information.pemilik_saham)"
            v-if="editingStatus && editingUser"></i>
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Person In Charge
        <span class="edit-info" v-if="editingStatus && editingUser"><i class="fa fa-edit" @click="addPIC()"></i></span>
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Nama</div>
        <div class="column20">Nomor Handphone</div>
        <div class="column55">Email</div>
        <div class="column5">&nbsp;</div>
      </div>
      <div class="info-list-usaha" v-for="(list, index) in information.pic" :key="index">
        <div class="column20">{{ $get(list, 'nama', '-') }}</div>
        <div class="column20">{{ $get(list, 'no_handphone', '-') }}</div>
        <div class="column55">{{ $get(list, 'email', '-') }}</div>
        <div class="column5">
          <i class="fa fa-edit pointer" @click="showPic(list)" v-if="editingStatus && editingUser"></i>
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Afiliasi</div>
      <div class="info-content">
        {{
          information.afiliasi_bce == 1 ||
            information.afiliasi_gems == 1 ||
            information.afiliasi_bkes == 1
            ? 'Affiliated -'
            : 'No'
        }}
        {{ information.afiliasi_bce == 1 ? 'BCE' : null }}
        {{ information.afiliasi_gems == 1 ? 'GEMS' : null }}
        {{ information.afiliasi_bkes == 1 ? 'BKES' : null }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Hubungan Dengan Sinarmas Mining Group</div>
      <div class="info-content">
        {{ information.relasi_desc_bce ? information.relasi_desc_bce : '-' }}
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">
        Identitas Nama Orang Yang Bersangkutan
      </div>
      <div class="info-list-usaha text-grey">
        <div class="column20">Nama</div>
        <div class="column20">Jabatan</div>
        <div class="column60">Department</div>
      </div>
      <div class="info-list-usaha">
        <div class="column20">
          {{
            information.relasi_nama_bce ||
            information.relasi_nama_gems ||
            information.relasi_nama_bkes
          }}
        </div>
        <div class="column20">
          {{
            information.relasi_jabatan_bce ||
            information.relasi_jabatan_gems ||
            information.relasi_jabatan_bkes
          }}
        </div>
        <div class="column60">
          {{
            information.relasi_departemen_bce ||
            information.relasi_departemen_gems ||
            information.relasi_departemen_bkes
          }}
        </div>
      </div>
    </div>
    <div class="information-wrapper">
      <div class="info-title">Surat Izin Operasi (SIO)</div>
      <div class="info-content">
        {{ information.sio && information.sio.length > 0 ? 'Yes' : 'No' }}
      </div>
    </div>

    <div class="information-wrapper" v-if="md_landingpage && md_landingpage.length > 0" v-for="(list) in md_landingpage"
      :key="list.id">
      <div class="info-title">
        {{ list.text }}
      </div>
      <div class="info-content" v-if="list.question_type == 'attachment'">
        <label class="btn btn-default btn-file" @click="downloadAdditionalData(list.form_sub_value)">
          <i class="fas fa-download mr10"></i>
          <span class="all-column">{{
            getOriginalFileName(list.form_sub_value)
          }}</span>
        </label>
      </div>
      <div class="info-content" v-if="list.question_type == 'date-range'">{{ formatDate(list.form_value) }} - {{
        formatDate(list.form_sub_value) }}</div>
      <div class="info-content" v-if="list.question_type !== 'date-range' && list.question_type !== 'attachment'">{{
        list.form_value }}</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
import addPemilikSahamVue from '../../components/modalLandingPage/addPemilikSaham.vue'

export default {
  components: {
    EditInfo: () => import('@/components/modal/EditInfo.vue'),
    IUJP: () => import('@/components/modal/iujp.vue'),
    IUJPTL: () => import('@/components/modal/iujptl.vue'),
    INUBBM: () => import('@/components/modal/inubbm.vue'),
    SBUJK: () => import('@/components/modal/sbujk.vue'),
    DirekturEdit: () => import('@/components/modal/direktur.vue'),
    KomisarisEdit: () => import('@/components/modal/komisaris.vue'),
    PemilikSahamEdit: () => import('@/components/modal/pemilikSaham.vue'),
    PICEdit: () => import('@/components/modal/pic.vue'),
    IdentityEdit: () => import('@/components/modal/identity.vue'),
    // KbliEdit: () => import('@/components/modal/kbliEdit.vue'),
    SubKbliEdit: () => import('@/components/modal/SubKbliEdit.vue'),
    AddKbli: () => import('@/components/modal/AddKbli.vue'),
  },
  data() {
    return {
      api: api,
      iujp: [
        {
          id: 1,
          jenis: 'Konsultasi',
          bidang: 'Penyelidikan Umum',
          sub_bidang: 'Survei Tinjau (Reconnaissance)',
          createdAt: '2021-11-17T07:29:06.000Z',
          updatedAt: '2021-11-17T07:29:06.000Z',
        },
      ],
      iujptl: [
        {
          id: 1,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Uap',
          kualifikasi: 'Kecil/Menengah/Besar',
          createdAt: '2021-11-17T07:29:06.000Z',
          updatedAt: '2021-11-17T07:29:06.000Z',
        },
        {
          id: 2,
          jenis_usaha:
            'Konsultansi Dalam Bidang Instalasi Penyediaan Tenaga Listrik',
          bidang: 'Pembangkitan Tenaga Listrik',
          sub_bidang: 'Pembangkit Listrik Tenaga Gas',
          kualifikasi: 'Kecil/Menengah/Besar',
          createdAt: '2021-11-17T07:29:06.000Z',
          updatedAt: '2021-11-17T07:29:06.000Z',
        },
      ],
      inubbm: [
        {
          id: 1,
          desc: 'Pengangkutan Bahan Bakar Minyak',
          createdAt: '2021-11-17T07:29:05.000Z',
          updatedAt: '2021-11-17T07:29:05.000Z',
        },
      ],
      sbujk: [
        {
          id: 1,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR101',
          sub_klasifikasi: 'Jasa Nasihat dan Pra Desain Arsitektural',
          kualifikasi: 'Kecil/Menengah/Besar',
          createdAt: '2021-11-23T07:56:46.000Z',
          updatedAt: '2021-11-23T07:56:46.000Z',
        },
      ],
      direktur: {
        jabatan: 'Direktur Utama',
        name: 'Bhakti',
        phoneNumber: '+62 8123123124',
        email: 'bhakti@graha.com',
      },
      komisaris: {
        jabatan: 'Komisaris Utama',
        name: 'Bhakti',
        phoneNumber: '+62 8123123124',
        email: 'bhakti@graha.com',
      },
      identity: {
        name: 'Bhakti',
        jabatan: 'Sales',
        department: 'Marketing',
      },
      pic: {
        name: 'Bhakti',
        phoneNumber: '+62 8123123124',
        email: 'bhakti@graha.com',
      },
      pemilikSaham: {
        name: 'Bhakti',
        nominal: 100,
      },
      kbliEditData: null,
    }
  },
  computed: {
    information() {
      return this.$store.state.level1.information
    },
    editingStatus() {
      return this.$get(
        this.$store,
        'state.editingStore.information_level_1.is_open',
        0
      )
    },
    editingUser() {
      return (
        this.$get(
          this.$store,
          'state.editingStore.information_level_1.user_id',
          ''
        ) == this.$get(this.$store, 'state.userid', 0)
      )
    },
    md_landingpage() {
      return this.$store.state.level1.md_landingpage
    },
  },
  methods: {
    getOriginalFileName(filepath, placeholder = 'No File') {
      if (filepath) {
        let split = filepath.split('/')
        return split[split.length - 1]
      }

      return placeholder
    },
    showIujp() {
      const info = this.$store.state.level1.information
      if (info.iujp && info.iujp.length > 0) {
        let storeIujp = []
        for (let i in info.iujp) {
          let newIujp = info.iujp[i].master_iujp
          if (newIujp) {
            newIujp['checked'] = true
            newIujp['id_iujp_vendor'] = info.iujp[i].id
            storeIujp.push(newIujp)
          }
        }
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedIujp',
          value: storeIujp,
        })
      }
      this.$store.commit('modalStore/SET_IUJP_MODAL', true)
    },
    showIujptl() {
      const info = this.$store.state.level1.information
      if (info.iujptl && info.iujptl.length > 0) {
        let storeIujptl = []
        for (let i in info.iujptl) {
          let newIujptl = info.iujptl[i].master_iujptl
          if (newIujptl) {
            newIujptl['checked'] = true
            newIujptl['id_iujptl_vendor'] = info.iujptl[i].id
            storeIujptl.push(newIujptl)
          }
        }
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedIujptl',
          value: storeIujptl,
        })
      }
      this.$store.commit('modalStore/SET_IUJPTL_MODAL', true)
    },
    showInubbm() {
      const info = this.$store.state.level1.information
      if (info.inu_bbm && info.inu_bbm.length > 0) {
        let storeInubbm = []
        for (let i in info.inu_bbm) {
          let newInubbm = info.inu_bbm[i].master_inu_bbm
          if (newInubbm) {
            newInubbm['checked'] = true
            newInubbm['id_inu_bbm_vendor'] = info.inu_bbm[i]['id']
            storeInubbm.push(newInubbm)
          }
        }
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedInubbm',
          value: storeInubbm,
        })
      }
      this.$store.commit('modalStore/SET_INUBBM_MODAL', true)
    },
    showSbujk() {
      const info = this.$store.state.level1.information
      if (info.sbujk && info.sbujk.length > 0) {
        let storeSbujk = []
        for (let i in info.sbujk) {
          let newSbujk = info.sbujk[i].master_sbujk
          if (newSbujk) {
            newSbujk['checked'] = true
            newSbujk['id_sbujk_vendor'] = info.sbujk[i].id
            storeSbujk.push(newSbujk)
          }
        }
        this.$store.commit('addEdit/SET_STATE_DATA', {
          name: 'choosedSbujk',
          value: storeSbujk,
        })
      }
      this.$store.commit('modalStore/SET_SBUJK_MODAL', true)
    },
    sortDirekturKomisaris(list) {
      if (list && list.length > 0) {
        let newList = []
        for (let i in list) {
          if (
            (list[i].jabatan &&
              list[i].jabatan.toUpperCase() == 'DIREKTUR UTAMA') ||
            list[i].jabatan.toUpperCase() == 'KOMISARIS UTAMA'
          ) {
            newList.unshift(list[i])
          } else {
            newList.push(list[i])
          }
        }
        return newList
      }
      return []
    },
    async showDirektur(data) {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddDirektur',
        value: false,
      })
      await this.$store.commit('modalStore/SET_DIREKTUR_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'direkturDetail',
        value: data,
      })
    },
    async addDirektur(list) {
      let jabatan = 'DIREKTUR UTAMA'
      if (list && list.length > 0) {
        const filterJabatan = await list.filter(
          i => i.jabatan.toUpperCase() == 'DIREKTUR UTAMA'
        )
        if (filterJabatan && filterJabatan.length > 0) {
          jabatan = 'DIREKTUR'
        }
      }
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddDirektur',
        value: true,
      })
      await this.$store.commit('modalStore/SET_DIREKTUR_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'direkturDetail',
        value: { vendor_id: this.$store.state.level1.vendorId, jabatan },
      })
    },
    async showKomisaris(data) {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddKomisaris',
        value: false,
      })
      await this.$store.commit('modalStore/SET_KOMISARIS_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'komisarisDetail',
        value: data,
      })
    },
    async addKomisaris(list) {
      let jabatan = 'KOMISARIS UTAMA'
      if (list && list.length > 0) {
        const filterJabatan = await list.filter(
          i => i.jabatan.toUpperCase() == 'KOMISARIS UTAMA'
        )
        if (filterJabatan && filterJabatan.length > 0) {
          jabatan = 'KOMISARIS'
        }
      }
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddKomisaris',
        value: true,
      })
      await this.$store.commit('modalStore/SET_KOMISARIS_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'komisarisDetail',
        value: { vendor_id: this.$store.state.level1.vendorId, jabatan },
      })
    },
    sumSaham(data, saham) {
      let persen = saham && saham.persen ? saham.persen : 0
      if (data && data.length > 0) {
        let sumPersen = 0
        for (let i in data) {
          if (data[i].persen) {
            sumPersen += Number(data[i].persen)
          }
        }
        return sumPersen - Number(persen)
      }
      return 0
    },
    async showPemilikSaham(data, info) {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddPemilikSaham',
        value: false,
      })
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'totalSaham',
        value: this.sumSaham(info, data),
      })
      await this.$store.commit('modalStore/SET_SAHAM_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'pemilikSahamDetail',
        value: data,
      })
    },
    async addPemilikSaham(list) {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddPemilikSaham',
        value: true,
      })
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'totalSaham',
        value: this.sumSaham(list, 0),
      })
      await this.$store.commit('modalStore/SET_SAHAM_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'pemilikSahamDetail',
        value: { vendor_id: this.$store.state.level1.vendorId },
      })
    },
    async showPic(data) {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddPic',
        value: false,
      })
      await this.$store.commit('modalStore/SET_PIC_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'picDetail',
        value: data,
      })
    },
    async addPIC() {
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'isAddPic',
        value: true,
      })
      await this.$store.commit('modalStore/SET_PIC_MODAL', true)
      await this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'picDetail',
        value: { vendor_id: this.$store.state.level1.vendorId },
      })
    },
    showIdentity() {
      this.$store.commit('modalStore/SET_IDENTITY_MODAL', true)
    },
    async editInfo() {
      await this.$store.dispatch('addEdit/getInformasi', {
        vendor_id: this.$get(this.$store, 'state.level1.vendorId'),
      })
      await this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'showEditInfo',
        status: true,
      })
    },
    addKbli(data) {
      this.kbli = [...this.kbli, ...data]
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addKbli',
        status: false,
      })
    },
    editKbliId(list) {
      this.kbliEditData = list
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'subKbliEdit',
        status: true,
      })
    },
    showKbliEdit() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addKbli',
        status: true,
      })
    },
    async downloadAdditionalData(link) {
      if (link) {
        let linkUrl = `${api}/vendor-add-doc/${link}`
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
  },
}
</script>
